import { render, staticRenderFns } from "./customerList.vue?vue&type=template&id=b5479c4e&scoped=true"
import script from "./customerList.vue?vue&type=script&lang=js"
export * from "./customerList.vue?vue&type=script&lang=js"
import style0 from "./customerList.vue?vue&type=style&index=0&id=b5479c4e&lang=less"
import style1 from "./customerList.vue?vue&type=style&index=1&id=b5479c4e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5479c4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5479c4e')) {
      api.createRecord('b5479c4e', component.options)
    } else {
      api.reload('b5479c4e', component.options)
    }
    module.hot.accept("./customerList.vue?vue&type=template&id=b5479c4e&scoped=true", function () {
      api.rerender('b5479c4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/customer/customerList.vue"
export default component.exports